/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { OffersStep } from 'legacy/events/offers.types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from 'legacy/common/components/wysiwyg-form/Header';
import CreateOfferPage from './CreateOfferPage';
import OfferDetailPage from './OfferDetailPage';
import OffersList from './OffersList';
import { useEventEditorContext } from '../../../contexts/EventEditorContext';

export const offersStepMap = {
  [OffersStep.CREATE_OFFER]: CreateOfferPage,
  [OffersStep.OFFERS_LIST]: OffersList,
  [OffersStep.EDIT_OFFER]: CreateOfferPage,
  [OffersStep.OFFER_DETAILS]: OfferDetailPage
};

const getOffersStepTitle = (offersStep: OffersStep, t: (key: string) => string) => {
  switch (offersStep) {
    case OffersStep.CREATE_OFFER:
      return t('settings.promoterOffers.page.stepTitles.newOffer');
    case OffersStep.OFFERS_LIST:
      return t('settings.promoterOffers.page.stepTitles.offers');
    case OffersStep.EDIT_OFFER:
      return t('settings.promoterOffers.page.stepTitles.editOffer');
    case OffersStep.OFFER_DETAILS:
      return t('settings.promoterOffers.page.stepTitles.offerDetails');
    default:
      return t('settings.promoterOffers.page.stepTitles.offers');
  }
};

const OffersPage = () => {
  const { t } = useTranslation(['events']);
  const {
    eventId,
    offersStep,
    setOffersStep,
    handleOfferBackNavigation,
    isDraft,
    isEditing,
    isLoading,
    lastUpdated,
    handleBack,
    navigateToEventSettings
  } = useEventEditorContext();

  const [offerId, setOfferId] = useState<string>(undefined);

  const OffersStepComponent = offersStepMap[offersStep];
  return (
    <>
      <Header
        isDraft={isDraft}
        isEditing={isEditing}
        title={getOffersStepTitle(offersStep, t)}
        isLoading={isLoading}
        lastUpdated={lastUpdated}
        onBack={handleBack}
        onMenuClick={navigateToEventSettings}
      />
      <OffersStepComponent
        offerId={offerId}
        eventId={eventId}
        onClose={handleOfferBackNavigation}
        step={offersStep}
        setOffersStep={setOffersStep}
        setOfferId={setOfferId}
      />
    </>
  );
};

export default OffersPage;
